import { SentenceRetrievalResult } from 'schemas/SentenceRetrievalResultSchema'
import { TimeZoneStrings } from 'enums/TimeZone'
import { getStreamDataFromDocumentAndSentence } from 'utils/streamDataUtil'

export const createStreamWidgetDataFromSentenceRetrieval = (
  searchResult: SentenceRetrievalResult,
  timeZone: TimeZoneStrings
) => {
  let deletedSentenceCount = 0
  let deletedSentenceDateRangeFrom: number | undefined
  let deletedSentenceDateRangeTo: number | undefined

  const { documents, sentences, concepts } = searchResult
  const soundbites = sentences!.map((sentence, sentenceIndex) => {
    const document = documents![sentences![sentenceIndex]!.documentIdx!]
    const streamData = getStreamDataFromDocumentAndSentence(
      document,
      sentence,
      timeZone,
      sentence.properties.annotatedSentiment,
      true,
      true
    )

    if (document.deleted) {
      deletedSentenceCount += 1

      if (
        !deletedSentenceDateRangeFrom ||
        Number(document.properties.datetime!) < deletedSentenceDateRangeFrom
      ) {
        deletedSentenceDateRangeFrom = Number(document.properties.datetime!)
      }

      if (
        !deletedSentenceDateRangeTo ||
        Number(document.properties.datetime!) > deletedSentenceDateRangeTo
      ) {
        deletedSentenceDateRangeTo = Number(document.properties.datetime!)
      }
    } else {
      streamData.concepts =
        concepts!
          .filter(
            (concept) =>
              concept.documentIdx === sentence.documentIdx && concept.sentenceIdx === sentenceIndex
          )
          .map((concept) => concept) || []
    }

    return streamData
  })

  return {
    soundbites,
    deletedSentenceCount,
    deletedSentenceDateRangeFrom,
    deletedSentenceDateRangeTo
  }
}

export default createStreamWidgetDataFromSentenceRetrieval
